module.exports = __webpack_public_path__ + "static/indigo-130a527b976a426e68a14f78cc91d828.jpg";